import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getfreeprod,getStoreSeries } from "../api/service";
import { FaShoppingCart,FaTrash  } from "react-icons/fa";
/* ─────────────────────────────────────────────
   LUXURY PREMIUM CART PAGE
   High-end design with gold accents, glass morphism
   Smooth animations, premium typography
───────────────────────────────────────────── */

const PREMIUM_CART_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;500;600;700&family=Inter:wght@300;400;500;600;700;800&display=swap');
html, body, #root {
  -webkit-text-size-adjust: 100%;
  -moz-text-size-adjust: 100%;
  text-size-adjust: 100%;
}
  :root {
    --gold: #d4af37;
    --gold-light: #f5e6b8;
    --gold-dark: #b8960c;
    --cream: #faf8f2;
    --cream-dark: #f0ebe0;
    --charcoal: #1c1c1e;
    --charcoal-light: #2c2c2e;
    --slate: #6b6b6b;
    --muted: #9e9e9e;
    --white: #ffffff;
    --black: #0a0a0a;
    --green: #2e7d32;
    --green-light: #e8f5e9;
    --red: #c62828;
    --red-light: #ffebee;
    --shadow-sm: 0 4px 20px rgba(0,0,0,0.08);
    --shadow-md: 0 8px 32px rgba(0,0,0,0.12);
    --shadow-lg: 0 16px 48px rgba(0,0,0,0.16);
    --shadow-xl: 0 24px 64px rgba(0,0,0,0.2);
    --radius-sm: 12px;
    --radius-md: 20px;
    --radius-lg: 28px;
    --radius-xl: 36px;
    --font-serif: 'Cormorant Garamond', serif;
    --font-sans: 'Inter', system-ui, sans-serif;
  }

  /* Global styles */
  .premium-cart-root {
    font-family: var(--font-sans);
    background: linear-gradient(135deg, var(--cream) 0%, var(--cream-dark) 100%);
    min-height: 100vh;
    width: 100%;
    margin: 0 ;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow-x: hidden;
  }

  /* Premium Header */
  .premium-header {
    background: linear-gradient(135deg, var(--charcoal) 0%, var(--black) 100%);
    padding: 0 20px;
    position: sticky;
    top: 0;
    z-index: 100;
    backdrop-filter: blur(20px);
    border-bottom: 1px solid rgba(212, 175, 55, 0.2);
  }
  .premium-header-inner {
    display: flex;
    align-items: center;
    height: 72px;
    gap: 16px;
  }
  .premium-back-btn {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: rgba(255,255,255,0.08);
    border: 1px solid rgba(212, 175, 55, 0.3);
    color: var(--gold);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 24px;
    font-weight: 300;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    backdrop-filter: blur(10px);line-height: 1;
padding: 0;
  }
  .premium-back-btn:hover {
    background: rgba(212, 175, 55, 0.15);
    border-color: var(--gold);
    transform: scale(1.05);
  }
  .premium-header-title {
    flex: 1;
    font-family: var(--font-serif);
    font-size: 20px;
    font-weight: 700;
    // background: linear-gradient(135deg, #fff 0%, var(--gold) 100%);
    color:#ffffff;
    -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
    letter-spacing: -0.5px;
  }
  .premium-header-count {
    background: #c62828;
    color: #ffffff;
    font-size: 13px;
    font-weight: 800;
    padding: 6px 14px;
    border-radius: 30px;
    box-shadow: 0 2px 8px rgba(212, 175, 55, 0.3);
  }

  /* Premium Body */
  .premium-body {
    flex: 1;
    overflow-y: auto;
    padding: 20px 20px 140px;
    scrollbar-width: thin;
  }
  .premium-body::-webkit-scrollbar {
    width: 4px;
  }
  .premium-body::-webkit-scrollbar-track {
    background: var(--cream-dark);
    
  }
  .premium-body::-webkit-scrollbar-thumb {
    background: var(--gold);
    border-radius: 10px;
  }

  /* Premium Summary Card */
  .premium-summary {
    background: linear-gradient(135deg, var(--charcoal) 0%, var(--black) 100%);
    border-radius: var(--radius-lg);
    padding: 20px;
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid rgba(212, 175, 55, 0.2);
    box-shadow: var(--shadow-lg);
    position: relative;
    overflow: hidden;
  }
  .premium-summary::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, var(--gold), transparent);
  }
  .premium-summary-item {
    text-align: center;
    flex: 1;
  }
  .premium-summary-label {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    color: var(--gold);
    font-weight: 600;
    margin-bottom: 6px;
  }
  .premium-summary-value {
    font-size: 16px;
    font-weight: 800;
    color: #fff;
  
  }
  .premium-summary-divider {
    width: 1px;
    height: 50px;
    background: linear-gradient(180deg, transparent, rgba(212,175,55,0.3), transparent);
  }

  /* Section Heading */
  .premium-section-head {
    font-family: var(--font-serif);
    font-size: 22px;
    font-weight: 600;
    color: var(--charcoal);
    margin-bottom: 20px;
    padding-bottom: 8px;
    border-bottom: 2px solid var(--gold);
    display: inline-block;
    letter-spacing: -0.3px;
  }

  /* Premium Cart Item */
  .premium-cart-item {
    background: var(--white);
    border-radius: var(--radius-md);
    padding: 16px;
    margin-bottom: 12px;
    display: flex;
    gap: 14px;
    box-shadow: var(--shadow-sm);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border: 1px solid rgba(212, 175, 55, 0.1);
    position: relative;
    overflow: hidden;
  }
  .premium-cart-item::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background: linear-gradient(180deg, var(--gold), var(--gold-dark));
    transform: scaleY(0);
    transition: transform 0.3s ease;
  }
  .premium-cart-item:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-md);
    border-color: rgba(212, 175, 55, 0.3);
  }
  .premium-cart-item:hover::before {
    transform: scaleY(1);
  }
  .premium-item-img {
    width: 60px;
    height: 70px;
    border-radius: var(--radius-sm);
    object-fit: cover;
    box-shadow: var(--shadow-sm);
    flex-shrink: 0;  
  }
  .premium-item-info {
    flex: 1;
    min-width: 0;  
  }
  .premium-item-name {
    font-size: 16px;
    font-weight: 700;
    color: var(--charcoal);
    margin-bottom: 6px;
    letter-spacing: -0.2px;
  }
  .premium-item-price {
    font-size: 18px;
    font-weight: 800;
    background: linear-gradient(135deg, var(--gold), var(--gold-dark));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 10px;
  }
  .premium-free-badge {
    display: inline-block;
    background: linear-gradient(135deg, var(--green), #1b5e20);
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: 20px;
    margin-bottom: 8px;
    letter-spacing: 0.5px;
  }

  /* Premium Quantity Controls */
  .premium-qty-wrap {
    display: flex;
    align-items: center;
    // gap: 8px;
    background: linear-gradient(135deg, #f5f5f5, #e8e8e8);
    border-radius: 40px;
    padding: 4px;
    width: fit-content;
  }
  .premium-qty-btn {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    border: none;
    cursor: pointer;
    background: var(--white);
    color: var(--charcoal);
    font-size: 18px;
    font-weight: 700;
    transition: all 0.2s ease;
    box-shadow: var(--shadow-sm);
  }
  .premium-qty-btn:active {
    transform: scale(0.92);
  }

  .premium-qty-val {
    min-width: 40px;
    text-align: center;
    font-size: 16px;
    font-weight: 800;
    color: var(--charcoal);
  }

  /* Remove Button */
  .premium-remove-btn {
    width: 25px;
    height: 25px;

    border-radius: 50%;
    background: var(--red-light);
    border: none;
    cursor: pointer;
    color: var(--red);
    font-size: 16px;
    transition: all 0.2s ease;
    
  }
  .premium-remove-btn:active {
    transform: scale(0.88);
    background: var(--red);
    color: #fff;
  }

  /* Addon Section */
  .premium-addon-section {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px dashed rgba(212, 175, 55, 0.2);
  }
  .premium-addon-label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: var(--gold);
    margin-bottom: 8px;
  }
  .premium-addon-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 0;
    border-bottom: 1px solid rgba(0,0,0,0.05);
  }
  .premium-addon-img {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
  }
  .premium-addon-name {
    flex: 1;
    font-size: 13px;
    font-weight: 600;
    color: var(--slate);
  }
  .premium-addon-price {
    font-size: 13px;
    font-weight: 700;
    color: var(--gold-dark);
  }
  .premium-addon-qty-wrap {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .premium-addon-qty-btn {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    border: none;
    background: #f0f0f0;
    cursor: pointer;
    font-weight: 700;
    transition: all 0.2s;
  }
  .premium-addon-qty-btn:active {
    transform: scale(0.9);
  }

  /* Premium Bill Card */
  .premium-bill-card {
    background: linear-gradient(135deg, var(--white), #fafafa);
    border-radius: var(--radius-lg);
    padding: 20px;
    margin-top: 20px;
    border: 1px solid rgba(212, 175, 55, 0.2);
    box-shadow: var(--shadow-md);
  }
  .premium-bill-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid rgba(0,0,0,0.05);
  }
  .premium-bill-row:last-child {
    border-bottom: none;
  }
  .premium-bill-label {
    font-size: 14px;
    color: var(--slate);
    font-weight: 500;
  }
  .premium-bill-value {
    font-size: 14px;
    font-weight: 700;
    color: var(--charcoal);
  }
  .premium-bill-total-label {
    font-size: 18px;
    font-weight: 800;
    color: var(--charcoal);
  }
  .premium-bill-total-value {
    font-size: 28px;
    font-weight: 800;
    background: linear-gradient(135deg, var(--gold), var(--gold-dark));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  /* Premium Footer */
  .premium-footer {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 500px;
    background: linear-gradient(135deg, var(--charcoal) 0%, var(--black) 100%);
    padding: 16px 20px 24px;
    box-shadow: var(--shadow-xl);
    border-top: 1px solid rgba(212, 175, 55, 0.3);
    backdrop-filter: blur(20px);
  }
  .premium-footer-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }
  .premium-footer-total-label {
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    color: var(--gold);
    font-weight: 600;
  }
  .premium-footer-total-value {
    font-size: 32px;
    font-weight: 800;
    color: #fff;
    font-family: var(--font-serif);
  }
  .premium-footer-btns {
    display: flex;
    gap: 12px;
  }
  .premium-clear-btn {
    flex: 1;
    background: rgba(255,255,255,0.08);
    border: 1px solid rgba(212, 175, 55, 0.3);
    border-radius: 40px;
    color: #c62828;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  .premium-clear-btn:active {
    transform: scale(0.96);
    background: rgba(212, 175, 55, 0.15);
  }
.premium-checkout-btn {
  flex: 2;
  padding: 10px;
  background: #c62828;
  border: none;
  border-radius: 40px;
  color: #fff;
  font-size: 15px;
  font-weight: 800;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
  .premium-checkout-btn:active {
    transform: scale(0.96);
  }

  /* Premium Empty State */
  .premium-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 80px 20px;
    text-align: center;
  }
  .premium-empty-icon {
    font-size: 80px;
    margin-bottom: 20px;
    animation: float 3s ease-in-out infinite;
  }
  @keyframes float {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-10px); }
  }
  .premium-empty-title {
    font-family: var(--font-serif);
    font-size: 28px;
    font-weight: 700;
    color: var(--charcoal);
    margin-bottom: 8px;
  }
  .premium-empty-sub {
    font-size: 14px;
    color: var(--muted);
    margin-bottom: 24px;
  }
  .premium-empty-btn {
    background: linear-gradient(135deg, var(--gold), var(--gold-dark));
    color: var(--charcoal);
    border: none;
    border-radius: 40px;
    padding: 14px 36px;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.3s;
  }
  .premium-empty-btn:active {
    transform: scale(0.95);
  }

  /* Premium Modal */
  .premium-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.75);
    backdrop-filter: blur(8px);
    z-index: 200;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    animation: fadeIn 0.3s ease;
  }
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  .premium-sheet {
    background: var(--white);
    border-radius: var(--radius-xl) var(--radius-xl) 0 0;
    width: 100%;
    max-width: 500px;
    padding: 24px 20px 32px;
    animation: slideUp 0.3s ease;
  }
  @keyframes slideUp {
    from { transform: translateY(100%); }
    to { transform: translateY(0); }
  }
  .premium-sheet-handle {
    width: 50px;
    height: 4px;
    background: var(--gold);
    border-radius: 2px;
    margin: 0 auto 20px;
  }
  .premium-sheet-icon {
    width: 64px;
    height: 64px;
    background: linear-gradient(135deg, var(--gold-light), var(--gold));
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 16px;
    font-size: 32px;
  }
  .premium-sheet-title {
    font-family: var(--font-serif);
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    color: var(--charcoal);
    margin-bottom: 8px;
  }
  .premium-sheet-btns {
    display: flex;
    gap: 12px;
    margin-top: 24px;
  }
  .premium-sheet-cancel {
    flex: 1;
    padding: 14px;
    border: 1px solid rgba(212, 175, 55, 0.3);
    border-radius: 40px;
    background: transparent;
    font-weight: 700;
    cursor: pointer;
  }
  .premium-sheet-confirm {
    flex: 1;
    padding: 14px;
    background: #c62828;
    border: none;
    border-radius: 40px;
    font-weight: 700;
    cursor: pointer;
    color:#fff
  }
    @media screen and (min-width: 601px) {
  .premium-cart-root, .premium-footer {
    max-width: 100% !important;
    width: 100% !important;
  }
  .premium-cart-item { padding: 18px !important; }
  .premium-summary { padding: 24px !important; }
}
@media screen and (min-width: 601px) and (orientation: landscape) {
  .premium-cart-root, .premium-footer {
    max-width: 100% !important;
  }
}
`;

// Inject CSS
if (!document.getElementById("premium-cart-css")) {
  const el = document.createElement("style");
  el.id = "premium-cart-css";
  el.textContent = PREMIUM_CART_CSS;
  document.head.appendChild(el);
}

function CartPage() {
  const navigate = useNavigate();
 const [cart, setCart] = useState(() => {
  try { return JSON.parse(localStorage.getItem("cart") || "[]"); }
  catch { return []; }
});
  const [loading, setLoading] = useState(false);
  const [isCheckingOut, setIsCheckingOut] = useState(false);
  const [showClearConfirm, setShowClearConfirm] = useState(false);

  // Load cart
  // useEffect(() => {
  //   const stored = JSON.parse(localStorage.getItem("cart") || "[]");
  //   setCart(stored);
  // }, []);
useEffect(() => {
  if (showClearConfirm) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }
  return () => {
    document.body.style.overflow = "";
  };
}, [showClearConfirm]);
  const saveCart = (updated) => {
    localStorage.setItem("cart", JSON.stringify(updated));
    setCart(updated);
  };

  // Calculate totals
  let subtotal = 0, taxAmount = 0, total = 0;
  
  cart.forEach(product => {
    const qty = product.quantity || 1;
    const base = (product.sosPrice || 0) * qty;
    const taxPct = (product.tax1 || 0) + (product.tax2 || 0) + (product.tax3 || 0);
    const excl = base / (1 + taxPct / 100);
    const tax = base - excl;

    subtotal += excl;
    taxAmount += tax;
    total += base;

    (product.addons || []).forEach(addon => {
      const addonTotal = (addon.price || addon.sosPrice || 0) * (addon.qty || 1);
      total += addonTotal;
    });
  });

  const removeItem = (index) => {
    const newCart = cart.filter((_, i) => i !== index);
    saveCart(newCart);
  };

  const decreaseQty = (index) => {
    const item = cart[index];
    if ((item.quantity || 1) <= 1) {
      removeItem(index);
      return;
    }
    const newCart = cart.map((i, idx) => 
      idx === index ? { ...i, quantity: (i.quantity || 1) - 1 } : i
    );
    saveCart(newCart);
  };

  const increaseQty = (index) => {
    const newCart = cart.map((i, idx) => 
      idx === index ? { ...i, quantity: (i.quantity || 1) + 1 } : i
    );
    saveCart(newCart);
  };

  const changeAddonQty = (itemIdx, addonIdx, delta) => {
    const newCart = cart.map((item, i) => {
      if (i !== itemIdx) return item;
      const newAddons = item.addons.map((a, j) => {
        if (j !== addonIdx) return a;
        const newQty = (a.qty || 1) + delta;
        return newQty <= 0 ? null : { ...a, qty: newQty };
      }).filter(Boolean);
      return { ...item, addons: newAddons };
    });
    saveCart(newCart);
  };

  const clearCart = () => {
    localStorage.removeItem("cart");
    localStorage.removeItem("selectedFreeItems");
    localStorage.removeItem("allowedFreeQty");
    setCart([]);
    setShowClearConfirm(false);
  };

  const handleCheckout = async () => {
    if (isCheckingOut || cart.length === 0) return;
    setIsCheckingOut(true);
     const storeId = localStorage.getItem("StoreId");

    const series = await getStoreSeries(storeId);

     const discount = series?.discount ?? series?.Discount ?? series?.[0]?.discountPercent ?? 0;
     localStorage.setItem("checkoutTotal", total.toString());
localStorage.setItem("storeDiscount", discount.toString());

    navigate("/phoneNo", { state: { total ,discount,cart}, replace: true });
    setIsCheckingOut(false);
  };

  if (loading) {
    return (
      <div className="premium-cart-root">
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
          <div className="premium-loader-ring"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="premium-cart-root">
      {/* Premium Header */}
      <div className="premium-header">
        <div className="premium-header-inner">
          <button className="premium-back-btn" onClick={() => navigate("/menu")}>
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6" />
  </svg>
</button>
          <span className="premium-header-title">Your Cart</span>
          {cart.length > 0 && (
            <span className="premium-header-count">{cart.length} Items</span>
          )}
        </div>
      </div>

      {/* Premium Body */}
      <div className="premium-body" style={showClearConfirm ? { overflow: "hidden" } : {}}>
        {cart.length === 0 ? (
          <div className="premium-empty">
           <div className="premium-empty-icon">
  <FaShoppingCart size={40} />
</div>
            <div className="premium-empty-title">Your Cart is Empty</div>
            <div className="premium-empty-sub">Add some exquisite dishes to begin</div>
            <button className="premium-empty-btn" onClick={() => navigate("/menu")}>
              Explore Menu →
            </button>
          </div>
        ) : (
          <>
            {/* Premium Summary */}
            <div className="premium-summary">
              
              <div className="premium-summary-divider" />
              <div className="premium-summary-item">
                <div className="premium-summary-label">Subtotal</div>
                <div className="premium-summary-value">₹{subtotal.toFixed(2)}</div>
              </div>
              <div className="premium-summary-divider" />
              <div className="premium-summary-item">
                <div className="premium-summary-label">Tax</div>
                <div className="premium-summary-value">₹{taxAmount.toFixed(2)}</div>
              </div>
              <div className="premium-summary-divider" />
              <div className="premium-summary-item">
                <div className="premium-summary-label">Total</div>
                <div className="premium-summary-value">{total.toFixed(2)}</div>
              </div>
               <div className="premium-summary-divider" />
            </div>

            <div className="premium-section-head">Order Items</div>

            {/* Cart Items */}
            {cart.map((item, index) => {
              const qty = item.quantity || 1;
              const addonTotal = (item.addons || []).reduce((s, a) => s + (a.price || a.sosPrice || 0) * (a.qty || 1), 0);
              
              return (
                <div key={`${item.id}-${index}`} className="premium-cart-item">
                  <img className="premium-item-img" src={item.product_Imageurl} alt={item.product_Name} />
                  
                  {/* <div className="premium-item-info">
                    <div className="premium-item-name">{item.product_Name}</div>
                    
                    {item.prodType === 4 ? (
                      <span className="premium-free-badge">🎁 Complimentary</span>
                    ) : (
                      <div className="premium-item-price">₹{item.sosPrice}</div>
                    )}
                    
                    {item.prodType !== 4 && (
                      <div className="premium-qty-wrap">
                        <button className="premium-qty-btn" onClick={() => decreaseQty(index)}>−</button>
                        <span className="premium-qty-val">{qty}</span>
                        <button className="premium-qty-btn" onClick={() => increaseQty(index)}>+</button>
                      </div>
                    )}
                    
                 
                    {(item.addons || []).length > 0 && (
                      <div className="premium-addon-section">
                        <div className="premium-addon-label">Enhancements</div>
                        {item.addons.map((addon, ai) => (
                          <div key={`${addon.id}-${ai}`} className="premium-addon-row">
                            <img className="premium-addon-img" src={addon.imageurl} alt={addon.name} />
                            <span className="premium-addon-name">{addon.name}</span>
                            <span className="premium-addon-price">₹{addon.price || addon.sosPrice}</span>
                            <div className="premium-addon-qty-wrap">
                              <button className="premium-addon-qty-btn" onClick={() => changeAddonQty(index, ai, -1)}>−</button>
                              <span className="premium-addon-qty-val">{addon.qty || 1}</span>
                              <button className="premium-addon-qty-btn" onClick={() => changeAddonQty(index, ai, 1)}>+</button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div> */}


                  <div className="premium-item-info">
  <div className="premium-item-name">{item.product_Name}</div>

  {item.prodType === 4 ? (
    <span className="premium-free-badge">🎁 Complimentary</span>
  ) : (
    /* ── price + qty on the same line ── */
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 8 }}>
      
      {/* Price */}
      <div className="premium-item-price" style={{ marginBottom: 0 }}>
        ₹{item.sosPrice}
      </div>

      {/* Qty Controls */}
      <div className="premium-qty-wrap">
        <button className="premium-qty-btn" onClick={() => decreaseQty(index)}>−</button>
        <span className="premium-qty-val">{qty}</span>
        <button className="premium-qty-btn" onClick={() => increaseQty(index)}>+</button>
      </div>

    </div>
  )}

  {/* Addons */}
  {(item.addons || []).length > 0 && (
    <div className="premium-addon-section">
      <div className="premium-addon-label">Enhancements</div>
      {item.addons.map((addon, ai) => (
        <div key={`${addon.id}-${ai}`} className="premium-addon-row">
          <img className="premium-addon-img" src={addon.imageurl} alt={addon.name} />
          <span className="premium-addon-name">{addon.name}</span>
          <span className="premium-addon-price">₹{addon.price || addon.sosPrice}</span>
          <div className="premium-addon-qty-wrap">
            <button className="premium-addon-qty-btn" onClick={() => changeAddonQty(index, ai, -1)}>−</button>
            <span className="premium-addon-qty-val">{addon.qty || 1}</span>
            <button className="premium-addon-qty-btn" onClick={() => changeAddonQty(index, ai, 1)}>+</button>
          </div>
        </div>
      ))}
    </div>
  )}
</div>
                  
                  <button className="premium-remove-btn" onClick={() => removeItem(index)}>✕</button>
                </div>
              );
            })}

            {/* Premium Bill Card */}
            {/* <div className="premium-bill-card">
              <div className="premium-section-head" style={{ marginBottom: 16, fontSize: 18 }}>Bill Summary</div>
              <div className="premium-bill-row">
                <span className="premium-bill-label">Subtotal (excl. tax)</span>
                <span className="premium-bill-value">₹{subtotal.toFixed(2)}</span>
              </div>
              <div className="premium-bill-row">
                <span className="premium-bill-label">Taxes & Charges</span>
                <span className="premium-bill-value">₹{taxAmount.toFixed(2)}</span>
              </div>
              <div className="premium-bill-row">
                <span className="premium-bill-total-label">Grand Total</span>
                <span className="premium-bill-total-value">₹{total.toFixed(2)}</span>
              </div>
            </div> */}
          </>
        )}
      </div>

      {/* Premium Footer */}
      {cart.length > 0 && (
        <div className="premium-footer">
          
          <div className="premium-footer-btns">
            <button className="premium-clear-btn" onClick={() => setShowClearConfirm(true)}>
              Clear Cart
            </button>
        <button className="premium-checkout-btn" onClick={handleCheckout} disabled={isCheckingOut}>
  {isCheckingOut ? "Processing..." : (
    <>
      <span>Checkout ₹{total.toFixed(2)}</span>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="9 18 15 12 9 6" />
      </svg>
    </>
  )}
</button>
          </div>
        </div>
      )}

      {/* Clear Cart Modal */}
      {showClearConfirm && (
        <div className="premium-modal-overlay" onClick={() => setShowClearConfirm(false)}>
          <div className="premium-sheet" onClick={e => e.stopPropagation()}>
            <div className="premium-sheet-handle" />
            <div className="premium-sheet-icon"><FaTrash /></div>
            <div className="premium-sheet-title">Clear Your Cart?</div>
            <div style={{ textAlign: "center", color: "var(--muted)", marginBottom: 24 }}>
              You have {cart.length} item{cart.length !== 1 ? "s" : ""} in your cart
            </div>
            <div className="premium-sheet-btns">
              <button className="premium-sheet-cancel" onClick={() => setShowClearConfirm(false)}>Cancel</button>
              <button className="premium-sheet-confirm" onClick={clearCart}>Yes, Clear</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CartPage;